import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModalRoot from './ModalRoot';

class ModalContainer extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired
  };

  render() {
    const { isOpen, children } = this.props;
    return <ModalRoot>{isOpen && children}</ModalRoot>;
  }
}

const mapStateToProps = state => {
  return {
    isOpen: state.modal.isOpen
  };
};

export default connect(mapStateToProps)(ModalContainer);
